<template>
  <div style="font-weight: 400;">
    <v-btn @click="openDialog" style="width:100%;" color="indigo" class="btnColorUpdate">
      <span style="color:#fff;">기관정보수정</span>
    </v-btn>
  </div>


  <v-dialog v-model="dialog" height="800px" style="width: 500px;" class="fontNotoSans400" >
    <v-card style="padding: 20px !important;"> <!--elevation : 그림자-->
      <h2 style="text-align: center">기관정보수정</h2>
      <v-form class="wageClientInfoForm">
        
        <v-text-field prepend-inner-icon="mdi-note-text-outline" variant="outlined" label="사업자등록번호" type="text"
          v-model="form.sisul_biz_num" maxlength="11" :rules="bizNumberRule" color="indigo" autocomplete="off" />
          <DaumAddr @updateAddress="updateAddress" :addr="form.sisul_addr"/>
       
        <!-- <v-text-field :prepend-inner-icon="mdiMapLegend" variant="outlined" label="기관 주소" type="text"
          v-model="form.sisul_addr" maxlength="150" :rules="addrRule" color="indigo" autocomplete="off" /> -->
          <v-text-field prepend-inner-icon="mdi-phone-classic" variant="outlined" label="기관 전화번호" type="text"
          v-model="form.sisul_tell" maxlength="11" :rules="localNumberRule" color="indigo" autocomplete="off" />
        
          <v-select
              variant="outlined" 
              prepend-inner-icon="mdi-bank-outline"
              label="은행명"
              :items="bankValue"
              v-model="form.sisul_bank"
              color="indigo"
              autocomplete="off"
              class="comeWaySelect"
            ></v-select>

        <v-text-field prepend-inner-icon="mdi-wallet" variant="outlined" label="계좌번호(숫자만 입력해주세요.)" type="text"
          v-model="form.sisul_bank_num" maxlength="20" :rules="bankNumRule" color="indigo" autocomplete="off" />
        
        <v-text-field prepend-inner-icon="mdi-shield-account" variant="outlined" label="예금주" type="text"
          v-model="form.sisul_bank_owner" maxlength="10" :rules="bankOwnerRule" color="indigo" autocomplete="off" />

        <v-text-field prepend-inner-icon="mdi-account-tie" variant="outlined" label="대표자 성명" type="text"
          v-model="form.sisul_boss_name" maxlength="10" :rules="bossNameRule" color="indigo" autocomplete="off" />

        <v-text-field prepend-inner-icon="mdi-cellphone" variant="outlined" label="대표자 휴대폰 번호" type="text"
          v-model="form.sisul_boss_phone" maxlength="11" :rules="phoneNumberRule" color="indigo" autocomplete="off" />

        <v-text-field 
          prepend-inner-icon="mdi-email-variant" 
          variant="outlined" 
          label="대표자 이메일" 
          hint="이메일 형식을 맞춰주세요." 
          type="email"
          v-model="form.sisul_boss_email" 
          maxlength="50" 
          :rules="emailRule" 
          color="indigo" 
          autocomplete="off" 
        />

        <v-btn class="clientInfoBtn" @click="updateSsInfo">수정완료</v-btn>
        <v-btn @click="closeDialog" class="cancelRegistBtn">취소</v-btn>
      </v-form>
    </v-card>
    <div class="text-center">
      <v-snackbar v-model="snackbar" :snacktime="snacktime">
        {{ snacktext }}
      </v-snackbar>
    </div>

  </v-dialog>
  <div class="text-center">

  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';
import DaumAddr from '@/components/api/DaumAddr.vue'

import {
  emailRule,
  phoneNumberRule,
  bossNameRule,
  localNumberRule,
  addrRule,
  bizNumberRule,
  bankNumRule,
  bankOwnerRule
} from '@/composables/rules';
const emit = defineEmits(['success']);
const dialog = ref(false);
const snackbar = ref(false);
const snacktext = ref(`메일이 전송되었습니다. 인증번호는 5분간 유효합니다.`);
const snacktime = ref(5000);

const bankValue= [
'기업은행',
'국민은행',
'외환은행',
'수협은행',
'농협은행',
'지역농협',
'우리은행',
'SC제일은행',
'서울은행',
'한국씨티은행',
'대구은행',
'부산은행',
'광주은행',
'제주은행',
'전북은행',
'경남은행',
'새마을금고연합회',
'신협중앙회',
'하나은행',
'신한은행',
'케이뱅크',
'카카오뱅크',
'토스뱅크'
]
const store = useStore();

// 타입 정의
interface SisulInfo {
  sisul_id: string;
  sisul_addr: string;
  sisul_tell: string;
  sisul_boss_name: string;
  sisul_boss_phone: string;
  sisul_boss_email: string;
  sisul_biz_num: string;
  sisul_bank: string;
  sisul_bank_num: string;
  sisul_bank_owner: string;
}

interface State {
  SsInfoBox: SisulInfo;
}

const form = reactive({
  sisul_id: '',
  sisul_addr: '',
  sisul_tell: '',
  sisul_boss_name: '',
  sisul_boss_phone: '',
  sisul_boss_email: '',
  sisul_biz_num: '',
  sisul_bank: '',
  sisul_bank_num: '',
  sisul_bank_owner: '',
});
//eslint-disable-next-line
const updateAddress = (address: any) => {
  form.sisul_addr = `${address.address}`;
};
const openDialog = () => {
  dialog.value = true;
  const Ss = (store.state as State).SsInfoBox;
  form.sisul_id = Ss.sisul_id;
  form.sisul_addr = Ss.sisul_addr;
  form.sisul_tell = Ss.sisul_tell?.replace(/\D/g, '');
  form.sisul_boss_name = Ss.sisul_boss_name;
  form.sisul_boss_phone = Ss.sisul_boss_phone?.replace(/\D/g, '');
  form.sisul_boss_email = Ss.sisul_boss_email;
  form.sisul_biz_num = Ss.sisul_biz_num?.replace(/\D/g, '');
  form.sisul_bank = Ss.sisul_bank;
  form.sisul_bank_num = Ss.sisul_bank_num;
  form.sisul_bank_owner = Ss.sisul_bank_owner;
}

const closeDialog = () => {
  dialog.value = false;
}

const updateSsInfo = async () => {
  try {
    const checkAndLog = (rule: (v: string) => boolean | string, value: string, ruleName: string) => {
      const ruleResult = rule(value);
      if (typeof ruleResult === 'string') {
        alert(`${ruleName} 확인해주세요.`);
        return true;
      } else {
        return false;
      }
    };

    const isAddrValid = addrRule.some(rule => checkAndLog(rule, form.sisul_addr, '기관 주소를'));
    if (isAddrValid) return;

    const isBNValid = bossNameRule.some(rule => checkAndLog(rule, form.sisul_boss_name, '대표자 성명을'));
    if (isBNValid) return;

    const isBPValid = phoneNumberRule.some(rule => checkAndLog(rule, form.sisul_boss_phone, '대표자 휴대폰번호를'));
    if (isBPValid) return;

    const isBEValid = emailRule.some(rule => checkAndLog(rule, form.sisul_boss_email, '대표자 이메일을'));
    if (isBEValid) return;

    const response = await axios.put('/api/updateSsInfo', { form: form });
    const result = response.data;
    if (result.success === true) {
      emit('success');
      alert('기관정보 수정이 완료되었습니다.');
      dialog.value = false;
    } else {
      alert('기관정보 수정에 실패하였습니다. 관리자에게 문의해주세요.');
    }
  } catch (error) {
    alert('기관정보 수정을 처리할 수 없습니다.');
    console.error(error);
  }
};


</script>
<style scoped>
.spinner {
  width: 30px !important;
  margin: 0 0 18px 8px;
  display: flex;
  height: 30px !important;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  align-items: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>